import styled from 'styled-components'
import type { ScrollNavigationDirection } from 'hooks/useScrollNavigation'

interface ScrollNavigationIndicatorProps {
  progress: number
  direction: ScrollNavigationDirection | null
}

const Wrapper = styled.div<{ $direction: ScrollNavigationDirection }>`
  position: fixed;
  left: 50%;
  ${({ $direction }) => ($direction === 'prev' ? 'top: 24px;' : 'bottom: 24px;')}
  transform: translateX(-50%);
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #ffffff;
  border: 2px solid #4d4d4d;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 1000;
`

// Flèche grise remplie en gris foncé selon la progression du geste (décoratif : les boutons restent l'alternative)
export default function ScrollNavigationIndicator({
  progress,
  direction,
}: Readonly<ScrollNavigationIndicatorProps>) {
  if (!direction || progress <= 0) return null

  const clipId = `scroll-nav-clip-${direction}`
  const height = 24 * Math.min(progress, 1)
  // « suivant » se remplit du haut vers le bas (sens de la flèche), « précédent » du bas vers le haut
  const fillY = direction === 'next' ? 0 : 24 - height
  const arrow = direction === 'next' ? 'M12 3v14M5 11l7 7 7-7' : 'M12 21V7M5 13l7-7 7 7'

  return (
    <Wrapper $direction={direction} aria-hidden="true" data-testid="scroll-navigation-indicator">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" focusable="false">
        <defs>
          <clipPath id={clipId}>
            <rect x="0" y={fillY} width="24" height={height} />
          </clipPath>
        </defs>
        <path
          d={arrow}
          stroke="#bdbdbd"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d={arrow}
          stroke="#1a1a1a"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          clipPath={`url(#${clipId})`}
        />
      </svg>
    </Wrapper>
  )
}
